export default "__VITE_ASSET__DG28v3Ur__"